<div class="slider-wrap">
  <div class="slider">
    <input
      type="number"
      value={valueLeft}
      name={`${name}-1`} />
    <input
      type="number"
      value={valueRight}
      name={`${name}-2`} />
    <div class="track-wrap">
      <div class="track" bind:this={track} />
      <div
        class="progress"
        style={`left: calc(${progressLeft}%); width: calc(${progressRight - progressLeft}%);`} />
    </div>
    <div class="thumb left"><div /></div>
    <div class="thumb right right-0"><div /></div>
    <div
      class="thumb thumb-left"
      bind:this={thumbLeft}
      style={`left: calc(${progressLeft}%);`}
      tabindex="0"
      on:focus={() => (activeLeft = true)}
      on:blur={() => (activeLeft = false)}
      on:touchstart|preventDefault={thumbLeftDown}
      on:mousedown|preventDefault={thumbLeftDown}>
      <div />
    </div>
    <div
      class="thumb thumb-right"
      bind:this={thumbRight}
      style={`left: calc(${progressRight}%);`}
      tabindex="0"
      on:focus={() => (activeRight = true)}
      on:blur={() => (activeRight = false)}
      on:touchstart|preventDefault={thumbRightDown}
      on:mousedown|preventDefault={thumbRightDown}>
      <div />
    </div>
  </div>
</div>

<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  let max = 100;
  let min = 0;
  let step = 1;
  let valueLeft = min;
  let valueRight = max;
  let track = null;
  let thumbLeft = null;
  let thumbRight = null;
  let activeLeft = false;
  let activeRight = false;
  let showMinMax = true;
  let leftMax = valueRight;
  let rightMin = valueLeft;
  let onMoveLeft = onMove("left");
  let onMoveRight = onMove("right");
  let name = "input";

  export { min, max, step, valueLeft, valueRight, name };

  $: min = parseFloat(min);
  $: max = parseFloat(max);
  $: leftMax = valueRight;
  $: rightMin = valueLeft;
  $: valueLeft = parseFloat(Math.max(valueLeft, min));
  $: valueRight = parseFloat(Math.min(valueRight, max));
  $: if (min > valueLeft) valueLeft = min;
  $: if (max < valueRight) valueRight = max;
  $: progressLeft = ((valueLeft - min) / (max - min)) * 100;
  $: progressRight = ((valueRight - min) / (max - min)) * 100;
  $: if (thumbLeft) activeLeft ? thumbLeft.focus() : thumbLeft.blur();
  $: if (thumbRight) activeRight ? thumbRight.focus() : thumbRight.blur();

  function roundValue(value, min, step) {
    const offset = min % step;
    return Math.round((value - offset) / step) * step + offset;
  }

  function thumbLeftDown(e) {
    activeLeft = true;

    if ("touches" in e) {
      document.addEventListener("touchmove", onMoveLeft);
      addOnce("touchend", onUp);
    } else {
      document.addEventListener("mousemove", onMoveLeft);
      addOnce("mouseup", onUp);
    }
  }

  function thumbRightDown(e) {
    activeRight = true;

    if ("touches" in e) {
      document.addEventListener("touchmove", onMoveRight);
      addOnce("touchend", onUp);
    } else {
      document.addEventListener("mousemove", onMoveRight);
      addOnce("mouseup", onUp);
    }
  }

  function onMove(thumb) {
    return function(e) {
      if (!track) return;
      const { left, width } = track.getBoundingClientRect();
      const clickOffset = "touches" in e ? e.touches[0].clientX : e.clientX;
      const clickPos =
        Math.min(Math.max((clickOffset - left) / width, 0), 1) || 0;
      if (thumb === "left") {
        valueLeft = roundValue(min + clickPos * (max - min), min, step);
        if (valueLeft > valueRight) valueLeft = valueRight;
      } else {
        valueRight = roundValue(min + clickPos * (max - min), min, step);
        if (valueRight < valueLeft) valueRight = valueLeft;
      }
    };
  }

  function onUp(e) {
    e.stopPropagation();
    document.removeEventListener("touchmove", onMoveLeft);
    document.removeEventListener("mousemove", onMoveLeft);
    document.removeEventListener("touchmove", onMoveRight);
    document.removeEventListener("mousemove", onMoveRight);

    activeLeft = false;
    activeRight = false;
    dispatch('input', { valueLeft, valueRight });
  }

  function addOnce(name, cb) {
    const once = e => {
      cb(e);
      document.removeEventListener(name, once);
    };
    document.addEventListener(name, once);
  }
</script>

<style lang="postcss">
  input {
    @apply hidden;
  }

  .slider-wrap {
    @apply flex items-center;
    padding: 0 17px;
  }

  .slider {
    @apply relative flex flex-1 items-center select-none;
    min-height: 34px;
  }

  .track-wrap {
    @apply w-full absolute left-0 transform -translate-y-1/2;
    height: 4px;
    top: 50%;
  }

  .track {
    background: #ebebeb;
    @apply w-full h-full absolute;
  }

  .progress {
    background: linear-gradient(90deg, #fb381e 19.64%, #ffbe0a 107.74%);
    @apply h-full absolute;
  }

  .thumb {
    @apply absolute outline-none;
    top: 50%;
  }

  .thumb div {
    @apply w-3 h-3 absolute rounded-full transform -translate-y-1/2;
    background: #ffffff;
    border: 4px solid #fe6e02!important;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    width: 34px;
    height: 34px;
    left: -17px;
    top: 50%;
  }

  .thumb.left div,
  .thumb.right div {
    background: #ebebeb;
    border: 4px solid #ebebeb!important;
    box-shadow: none;
  }

  .thumb div::before {
    @apply absolute rounded-full bg-primary opacity-25 transform scale-0 transition duration-75 ease-in-out;
    width: 64px;
    height: 64px;
    left: -19px;
    top: -19px;
    content: "";
  }

  .thumb-left:hover div::before,
  .thumb-right:hover div::before {
    @apply scale-75;
  }

  .thumb-left:focus div::before,
  .thumb-right:focus div::before {
    @apply scale-100;
  }
</style>
